import React, { useState } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import Checkbox from '@mui/material/Checkbox';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import { getIcon } from '../../utils/IconHandler';
import { useTranslation } from 'react-i18next';

import './ExpandableRow.scss';

const ExpandableRow = ({ category, permissions, rolePermissions, onToggle, editable, selectedCount }) => {
  
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const totalCount = permissions.length;

  return (
    <>
      <TableRow className="expandable-row">
        <TableCell className="expandable-row-header" colSpan={2} onClick={() => setOpen(!open)}>
          <span style={{marginTop: '10px'}} className="roboto-light title-expandable-row">{category}</span>
          <div className="expandable-row-right">
            <span className="roboto-light title-expandable-row selected-count">{selectedCount}/{totalCount} {selectedCount === 1 ? t('selected_singular') : t('selected_plural')}</span>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
              className="icon-button"
              sx={{
                borderRadius: '4px',
                padding: '4px',
                minWidth: 'auto',
                width: 'auto',
                height: 'auto',
                '&:hover': {
                  backgroundColor: 'transparent'
                }
              }}
            >
              {open ? getIcon('chevronDown') : getIcon('chevronForward')}
            </IconButton>
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell className='role_inner_table' colSpan={2}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Table size="small" aria-label="permissions">
              <TableBody>
                {permissions.map((permission) => (
                  <TableRow key={permission.id}>
                    <TableCell component="th" scope="row" style={{ paddingLeft: '16px', verticalAlign: 'middle' }}>
                      <span className="roboto-light">{permission.label}</span>
                    </TableCell>
                    <TableCell align="right" style={{ paddingRight: '16px', verticalAlign: 'middle' }}>
                      <Checkbox
                        checked={rolePermissions.includes(permission.id)}
                        onChange={() => editable && onToggle(permission.id)}
                        disabled={!editable}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default ExpandableRow;